import { Component } from '@angular/core';

import { GlobalServices } from 'app/services/global.service';
import { MemberTypes } from 'app/models/ss-api/responses/login.response';
import {DynamicDialogRef} from 'primeng/dynamicdialog';
import {DynamicDialogConfig} from 'primeng/dynamicdialog';

export interface IAddCreditCardDialog {
    title: string;
    token: string;
}

@Component({
    selector: 'add-credit-card-dialog',
    styleUrls: ['./add-credit-card-dialog.component.css'],
    templateUrl: './add-credit-card-dialog.component.html'
})

export class AddCreditCardDialogComponent implements IAddCreditCardDialog {

    title: string;
    token: string;

    isMember: boolean;

    result: any;
    
    constructor(
        public ref: DynamicDialogRef,
        public config: DynamicDialogConfig,
        public gb : GlobalServices
    ) {
    }

	ngOnInit() {
		this.gb.CheckMemberInfo();

        this.isMember = this.gb.MemberType == MemberTypes.Member;
	}

    close() {
        this.ref.close();
    }

    confirm() {
        // we set dialog result as true on click on confirm button,
        // then we can get dialog result from caller code
        this.result = true;
        this.close();
	}
	


}
